export default "__VITE_ASSET__B4c9uhTP__"